import React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import Collection from './components/Changes';
import CollectionEmail from './components/Emails';
import ObjectEmail from './components/Change';
import CollectionFirearmTrace from './components/Firearm_Traces'

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, locations, states}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/emails`}>
				<CollectionEmail locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/firearm_traces`}>
				<CollectionFirearmTrace locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/emails/:id`}>
				<ObjectEmail locations={locations} states={states} baseUrl={`${match.url}`}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
